import React from 'react';
import { useIntl } from 'react-intl';
import { isString } from '@/lib/string-utils';
import useDocumentTitle from '@/hooks/useDocumentTitle';
import { UIA11yVisuallyHidden } from '@/components/ui/a11y';
import { jsx as _jsx } from "react/jsx-runtime";

var getMessages = function getMessages(descriptors, intl) {
  return descriptors.map(function (descriptor) {
    var id = isString(descriptor) ? descriptor : descriptor.id;
    var values = isString(descriptor) ? undefined : descriptor.values;
    return intl.formatMessage({
      id: id
    }, values);
  });
};

var AppDocumentTitle = function AppDocumentTitle(_ref) {
  var descriptors = _ref.descriptors;
  var intl = useIntl();
  var messages = getMessages(descriptors, intl);
  useDocumentTitle("".concat(messages.join(' — '), " | Motimate"));
  return /*#__PURE__*/_jsx(UIA11yVisuallyHidden, {
    as: "h1",
    children: messages[0]
  });
};

export default AppDocumentTitle;